import { useTranslation } from 'react-i18next';
import {
  TestStatus,
  TestStatusAccepted,
  TestStatusRejected,
  TestStatusWaiting,
  TestStatusForced,
} from '../../shared/tag/serializedTagTypes';

export const useDesktopStatusReason = (status: TestStatus): string => {
  const { t } = useTranslation();

  const statusObject: Record<TestStatus, string> = {
    // Accepted status
    [TestStatusAccepted.accepted]: t('Accepted'),
    [TestStatusAccepted.acceptedByRedirection]: t('Accepted'),
    // WAiting status
    [TestStatusWaiting.checking]: t('Currently checking'),
    [TestStatusWaiting.pending]: t('Pending'),
    [TestStatusWaiting.targetByEventPending]: t('Pending Event'),
    [TestStatusWaiting.waitingCodeResolution]: t('Pending code'),
    [TestStatusWaiting.waitingForSubsegmentCheck]: t('Pending'),
    // Rejected status
    [TestStatusRejected.rejected]: t('Rejected'),
    [TestStatusRejected.audienceRejected]: t('Audience Rejected'),
    [TestStatusRejected.targetPagesRejected]: t('Target Pages Rejected'),
    [TestStatusRejected.qaParametersRejected]: t('QA rejected'),
    [TestStatusRejected.triggerRejected]: t('Trigger rejected'),
    [TestStatusRejected.segmentRejected]: t('Segment rejected'),
    [TestStatusRejected.displayFrequency]: t('Display Frequency Rejected'),
    [TestStatusRejected.trafficRejected]: t('Traffic rejected'),
    [TestStatusRejected.oneVisitorOneTest]: t('1 test 1 visitor'),
    [TestStatusRejected.anotherSubsegmentAlreadyStarted]: t('Already assigned to another experience'),
    [TestStatusRejected.masterCampaignNotChecked]: t('Master campaign without modifications'),
    [TestStatusRejected.timeout]: t('Timeout'),
    [TestStatusRejected.deferredFailedLoading]: t('Deferred loading failed'),
    [TestStatusRejected.notPrioritizedYet]: t('Not prioritized'),
    [TestStatusRejected.campaignTypeRejectedByConsent]: t('Rejected by consent'),
    [TestStatusRejected.geolocationRejectedByConsent]: t('Geolocation rejected by consent'),
    [TestStatusRejected.screenshotModeRejected]: t('Screenshot mode rejected'),
    // Forced status
    [TestStatusForced.forceAccepted]: t('Display forced'),
    [TestStatusForced.forceRejected]: t('Hidden'),
  };

  return statusObject[status] || status || statusObject[TestStatusWaiting.pending];
};

export const useMobileRejectedReason = (status: TestStatusRejected): string => {
  const { t } = useTranslation();

  const statusObject: Record<TestStatusRejected, string> = {
    // Rejected status
    [TestStatusRejected.rejected]: t('Rejected'),
    [TestStatusRejected.audienceRejected]: t('Audience'),
    [TestStatusRejected.targetPagesRejected]: t('Target Pages'),
    [TestStatusRejected.qaParametersRejected]: t('QA'),
    [TestStatusRejected.triggerRejected]: t('Trigger'),
    [TestStatusRejected.segmentRejected]: t('Segment'),
    [TestStatusRejected.displayFrequency]: t('Display frequency'),
    [TestStatusRejected.trafficRejected]: t('Traffic'),
    [TestStatusRejected.oneVisitorOneTest]: t('1 test 1 visitor'),
    [TestStatusRejected.anotherSubsegmentAlreadyStarted]: t('Another experience'),
    [TestStatusRejected.masterCampaignNotChecked]: t('Master campaign without modifications'),
    [TestStatusRejected.timeout]: t('Timeout'),
    [TestStatusRejected.deferredFailedLoading]: t('Deferred loading failed'),
    [TestStatusRejected.notPrioritizedYet]: t('Not prioritized'),
    [TestStatusRejected.campaignTypeRejectedByConsent]: t('Consent'),
    [TestStatusRejected.geolocationRejectedByConsent]: t('Geolocation rejected by consent'),
    [TestStatusRejected.screenshotModeRejected]: t('Screenshot mode'),
  };

  return statusObject[status] || status || t('Pending');
};
